<!-- @format -->

<template>
  <div id="my-container">
    <div>
      <img :src="partnerBackgroundUrl2" class="bg" />
      <div
        v-if="!isAuthenticated"
        id="my-login-container"
        class="ui middle aligned center aligned grid"
      >
        <div class="row">
          <div
            class="sixteen wide mobile eight wide tablet five wide computer column"
          >
            <div class="ui">
              <div class="ui black card fluid">
                <div class="ui image">
                  <img :src="imageLink" />
                </div>
                <div class="content">
                  <div class="header">{{ appName }}</div>
                  <small>version 2.2</small>
                </div>
                <div class="extra content">
                  <a
                    @click.prevent="submitLogin"
                    :class="
                      'ui secondary large basic fluid submit button ' +
                        (loading ? 'loading' : '')
                    "
                    ><i class="ui icon lock"></i>Login</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isAuthenticated"
        class="ui large top pointing attached left menu"
      >
        <router-link to="/settings">
          <div class="ui dropdown icon item">
            <i class="ui wrench icon"></i>
          </div>
        </router-link>
        <div class="item">
          <strong v-if="appName == 'QuestLink'">Quest</strong>
          <strong v-else>Portfolio</strong>Link
        </div>

        <router-link
          class="item"
          v-bind:class="{ active: $route.path == '/v2/clients' }"
          to="/v2/clients"
          >Clients</router-link
        >
        <router-link
          class="item"
          v-bind:class="{ active: $route.path == '/v2/plans' }"
          to="/v2/plans"
          >Plans</router-link
        >
        <router-link
          v-if="appName != 'QuestLink'"
          class="item"
          v-bind:class="{ active: $route.path == '/customportfolios' }"
          to="/customportfolios"
          >Portfolios</router-link
        >
        <router-link
          v-if="canViewUsers(user)"
          class="item"
          v-bind:class="{ active: $route.path == '/users' }"
          to="/users"
          >Users
        </router-link>

        <div class="ui right menu">
          <a
            v-if="user.userPartners.length > 1"
            href="#"
            class="ui item "
            @click.prevent="showUserSwitchModal = true"
          >
            <i class="exchange icon"></i>
            <strong>{{ partnerName }}</strong>
          </a>
          <a href="#" class="ui item red" @click="submitLogout">
            <i class="external alternate icon"></i>
            <strong>Sign Out</strong>
          </a>
        </div>
      </div>

      <div v-if="isAuthenticated" class="ui main container fluid centered">
        <router-view></router-view>
      </div>
      <div v-if="isAuthenticated">
        <sui-modal v-model="showFeedBackModal">
          <sui-modal-header>Send FeedBack</sui-modal-header>
          <sui-modal-content image>
            <sui-modal-description v-if="!feedBackSuccess">
              <sui-header>Message</sui-header>
              <div class="ui form">
                <div class="field">
                  <textarea rows="5" v-model="feedBackMessage"></textarea>
                </div>
              </div>
            </sui-modal-description>
            <sui-modal-description v-if="feedBackSuccess">
              <div class="ui form" v-if="feedBackSuccess">
                <div class="ui green message">Thank you for feedback!</div>
              </div>
            </sui-modal-description>
          </sui-modal-content>

          <sui-modal-actions v-if="!feedBackSuccess">
            <sui-button positive @click="postFeedback">Send</sui-button>|
            <sui-button @click.native="cancelFeedback">Cancel</sui-button>
          </sui-modal-actions>
          <sui-modal-actions v-if="feedBackSuccess">
            <sui-button @click.native="cancelFeedback">Close</sui-button>
          </sui-modal-actions>
        </sui-modal>
      </div>
      <div v-if="isAuthenticated">
        <sui-modal v-model="showUserSwitchModal">
          <sui-modal-header>Switch Team</sui-modal-header>
          <sui-modal-content>
            <p>
              You have access to the following. Click on any of the below to
              switch to relevant team:
            </p>

            <table class="ui table">
              <tr
                v-for="d in take(
                  skip(
                    order(user.userPartners, 'partnerName', 'asc'),
                    pageNr * 10
                  ),
                  10
                )"
              >
                <td>
                  <a href="#" @click.prevent="clickChangePartner(d.partnerId)">
                    {{ d.partnerName }}
                  </a>
                </td>
              </tr>
              <tfoot v-if="user.userPartners.length > 10">
                <th style="text-align: right">
                  <a
                    class="ui tiny button"
                    v-if="user.userPartners.length > 10 && pageNr >= 1"
                    href="#"
                    @click.prevent="pageNr--"
                    >Previous Page
                  </a>
                  <a
                    class="ui tiny button"
                    v-if="user.userPartners.length > (pageNr + 1) * 10"
                    href="#"
                    @click.prevent="pageNr++"
                    >Next Page
                  </a>
                </th>
              </tfoot>
            </table>
          </sui-modal-content>

          <sui-modal-actions>
            <sui-button @click.native="showUserSwitchModal = false"
              >Cancel</sui-button
            >
          </sui-modal-actions>
        </sui-modal>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  getPartnerSettings,
  login,
  logout,
  sendFeedback,
  endWelcomeTour,
  BaseUrl,
  changePartner,
  getUserInfo,
} from "@/gateway";
import { mapState, mapActions, mapGetters } from "vuex";
import * as _ from "lodash";
export default {
  name: "layout",
  components: {},
  data() {
    return {
      imageLink: "",
      pageDetails: null,
      pageNr: 0,
      step: 0,
      displayWelcome: false,
      baseUrl: "",
      userName: "",
      password: "",
      loading: true,
      error: false,
      results: {},
      showFeedBackModal: false,
      showUserSwitchModal: false,
      rating: 5,
      feedBackSubject: "",
      feedBackMessage: "",
      feedBackSuccess: false,
    };
  },
  computed: {
    partnerBackgroundUrl() {
      if (this.$store.state.partnerBackgroundUrl)
        return this.$store.state.partnerBackgroundUrl;
      else return "";
    },
    appName() {
      if (this.$store.state.appName) return this.$store.state.appName;
      else return "";
    },
    user() {
      if (this.$store.state.user) return this.$store.state.user;
      else return "";
    },
    partnerId() {
      if (this.$store.state.partnerId) return this.$store.state.partnerId;
      else return 0;
    },
    partnerName() {
      if (this.$store.state.partnerName) return this.$store.state.partnerName;
      else return "na";
    },
    ...mapState,
    ...mapGetters(["isAuthenticated"]),
  },
  methods: {
    take: function(arr, size) {
      return _.take(arr, size);
    },
    skip: function(arr, size) {
      return _.drop(arr, size);
    },
    order: function(arr, val1, value2) {
      return _.orderBy(arr, [val1], [value2]);
    },
    async clickChangePartner(partnerid) {
      const response = await changePartner({ partnerId: partnerid });
      if (response) {
        this.$store.dispatch("loadSettings");
        this.showUserSwitchModal = false;
        location.reload();
        // return true;
      }
    },
    canViewUsers(user) {
      if (user.permissions) {
        if (user.permissions.includes("manageUsers")) {
          return true;
        } else return false;
      } else {
        return false;
      }
    },
    async nextStep() {
      this.step = this.step + 1;
      await endWelcomeTour();
    },
    async closeWelcome() {
      this.step = 0;
      this.displayWelcome = false;
      await endWelcomeTour();
    },
    valid: function(step) {
      if (step == 1) {
        return true;
      }
      if (step == 2) {
        return true;
      }
      if (step == 3) {
        return true;
      }
      if (step == 4) {
        return true;
      }
    },
    async postFeedback() {
      const response = await sendFeedback({
        message: this.$router.currentRoute.path + " - " + this.feedBackMessage,
      });

      this.feedBackSuccess = true;
    },
    async cancelFeedback() {
      this.feedBackMessage = "";
      this.showFeedBackModal = false;
      this.feedBackSuccess = false;
    },
    async submitLogin() {
      //    const redirectUrl = await login("auth0", this.userName, this.password);
      this.loading = true;
      location.href = BaseUrl + "/auth/auth0";
    },
    async submitLoginAuth() {
      const redirectUrl = await login("auth0", this.userName, this.password);

      location.href = redirectUrl;
    },
    async submitLogout() {
      const redirectUrl = await logout();
      location.href = redirectUrl;
    },
    async getResults() {
      var response = await getPartnerSettings();
    },
    ...mapActions(["initialLoad"]),
  },
  async mounted() {
    try {
      // console.log("page", window.location.href);
      await this.initialLoad();
      this.loading = false;
      this.error = false;
      this.baseUrl = BaseUrl;
    } catch (err) {
      this.loading = false;
      this.error = true;
    }

    this.$store.dispatch("loadSettings");
    document.title = this.$store.state.appName;
    // change favicon
    if (
      this.$store.state.appName == "QuestLink" ||
      this.$store.state.appName == "quest"
    ) {
      //https:acportfoliolink.blob.core.windows.net/assets/login7.jpg
       var link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href =
        "https://acportfoliolink.blob.core.windows.net/assets/quest-favicon.ico";
      this.imageLink =
        "https://acportfoliolink.blob.core.windows.net/assets/quest-rock-man-sm.jpg";
    } else {
      this.imageLink =
        "https://acportfoliolink.blob.core.windows.net/assets/login7.jpg";
    }
    this.getResults();
    //  const welcomeTourResponse = await getWelcomeTour();
    //  this.displayWelcome = welcomeTourResponse.success;
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Poppins");

a {
  color: green;
  opacity: 1;

  &.active--exact {
    color: darkgrey;
  }

  &:hover {
    color: lightgray;
    cursor: pointer;
  }
}

.ui {
  font-family: "Poppins", sans-serif;
}

.button {
  font-family: "Poppins", sans-serif;
}

html,
body {
  font-family: "Poppins", sans-serif;
  background: #f0f0f0;
}

.home {
  font-family: "Poppins", sans-serif;
}

h1 {
  font-family: "Poppins", sans-serif;
}

h2 {
  font-family: "Poppins", sans-serif;
}

h3 {
  font-family: "Poppins", sans-serif;
}

h4 {
  font-family: "Poppins", sans-serif;
}
h5 {
  font-family: "Poppins", sans-serif;
}

h6 {
  font-family: "Poppins Condensed", sans-serif;
}

header {
  font-family: "Poppins", sans-serif;
}

p {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
}

section {
  font-family: "Poppins", sans-serif;
  background: rgb(233, 233, 233);
  border-radius: 5px;
  padding: 1em 2em 1em 1em;
}

section .content {
  align-items: center;
}

SectionSelectable {
  text-align: center;
  font-family: "Poppins", sans-serif;
  background: rgb(233, 233, 233);
  border-radius: 5px;
  padding: 1em 2em 1em 1em;
  cursor: pointer;
}

SectionSelectable .active {
  cursor: text;
  font-weight: bold;
}

.ui.footer.form-page {
  /* Increased specificity for SO snippet priority */
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 20px;
}
#my-container {
  background: #f0f0f0;
  height: 100vh;
  width: 100%;
  margin: 0em;
}
#my-login-container {
  background: grey;
  height: 100vh;
  width: 100%;
  margin: 0em;
}
#content {
}
#content:after {
}

.main.container {
  // margin-top: 2em;
}
.main.menu {
  margin-top: 4em;
  border-radius: 0;
  border: none;
  box-shadow: none;
  transition: box-shadow 0.5s ease, padding 0.5s ease;
}
.main.menu .item img.logo {
  margin-right: 1.5em;
}
.overlay {
  float: left;
  margin: 0em 3em 1em 0em;
}
.overlay .menu {
  position: relative;
  left: 0;
  transition: left 0.5s ease;
}
.main.menu.fixed {
  background-color: #ffffff;
  border: 1px solid #ddd;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
}
.overlay.fixed .menu {
  left: 800px;
}
.text.container .left.floated.image {
  margin: 2em 2em 2em -4em;
}
.text.container .right.floated.image {
  margin: 2em -4em 2em 2em;
}

img.bg {
  /* Set rules to fill background */
  min-height: 100%;
  min-width: 1024px;

  /* Set up proportionate scaling */
  width: 100%;
  height: auto;

  /* Set up positioning */
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0.6;
}

@media screen and (max-width: 1024px) {
  img.bg {
    left: 50%;
    margin-left: -512px;
  }
}

.client-container {
  font-family: "Poppins", sans-serif;
  position: relative;
  z-index: 1;
  padding: 5em 0 0 0;
  margin: 0;
}

.client-container .cbg {
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url("https://assets.website-files.com/5c6eb35188c954830ec0365d/5c817444f2a0f7e7f938ae36_yacht-dtp.jpg")
    center center;
  background-size: cover;
  opacity: 0.7;
  width: 100%;
  height: 100%;
}

.client-container .cbgmenu {
  position: absolute;
  z-index: -1;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  background-size: cover;
  opacity: 0.65;
  width: 100%;
  height: 65px;
}

.client-container .cbgheader {
  font-family: "Poppins", sans-serif;
  color: rgba(46, 44, 44, 0.719);
  font-size: 2em;
  opacity: 1;
}

.fingerprint-spinner,
.fingerprint-spinner * {
  box-sizing: border-box;
}

.fingerprint-spinner {
  height: 64px;
  width: 64px;
  padding: 2px;
  overflow: hidden;
  position: relative;
}

.fingerprint-spinner .spinner-ring {
  position: absolute;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: #4d4d4d;
  animation: fingerprint-spinner-animation 1500ms
    cubic-bezier(0.68, -0.75, 0.265, 1.75) infinite forwards;
  margin: auto;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}

.fingerprint-spinner .spinner-ring:nth-child(1) {
  height: calc(60px / 9 + 0 * 60px / 9);
  width: calc(60px / 9 + 0 * 60px / 9);
  animation-delay: calc(50ms * 1);
}

.fingerprint-spinner .spinner-ring:nth-child(2) {
  height: calc(60px / 9 + 1 * 60px / 9);
  width: calc(60px / 9 + 1 * 60px / 9);
  animation-delay: calc(50ms * 2);
}

.fingerprint-spinner .spinner-ring:nth-child(3) {
  height: calc(60px / 9 + 2 * 60px / 9);
  width: calc(60px / 9 + 2 * 60px / 9);
  animation-delay: calc(50ms * 3);
}

.fingerprint-spinner .spinner-ring:nth-child(4) {
  height: calc(60px / 9 + 3 * 60px / 9);
  width: calc(60px / 9 + 3 * 60px / 9);
  animation-delay: calc(50ms * 4);
}

.fingerprint-spinner .spinner-ring:nth-child(5) {
  height: calc(60px / 9 + 4 * 60px / 9);
  width: calc(60px / 9 + 4 * 60px / 9);
  animation-delay: calc(50ms * 5);
}

.fingerprint-spinner .spinner-ring:nth-child(6) {
  height: calc(60px / 9 + 5 * 60px / 9);
  width: calc(60px / 9 + 5 * 60px / 9);
  animation-delay: calc(50ms * 6);
}

.fingerprint-spinner .spinner-ring:nth-child(7) {
  height: calc(60px / 9 + 6 * 60px / 9);
  width: calc(60px / 9 + 6 * 60px / 9);
  animation-delay: calc(50ms * 7);
}

.fingerprint-spinner .spinner-ring:nth-child(8) {
  height: calc(60px / 9 + 7 * 60px / 9);
  width: calc(60px / 9 + 7 * 60px / 9);
  animation-delay: calc(50ms * 8);
}

.fingerprint-spinner .spinner-ring:nth-child(9) {
  height: calc(60px / 9 + 8 * 60px / 9);
  width: calc(60px / 9 + 8 * 60px / 9);
  animation-delay: calc(50ms * 9);
}

@keyframes fingerprint-spinner-animation {
  100% {
    transform: rotate(360deg);
  }
}

.hollow-dots-spinner,
.hollow-dots-spinner * {
  box-sizing: border-box;
}

.hollow-dots-spinner {
  height: 15px;
  width: calc(30px * 3);
}

.hollow-dots-spinner .dot {
  width: 15px;
  height: 15px;
  margin: 0 calc(15px / 2);
  border: calc(15px / 5) solid #4d4d4d;
  border-radius: 50%;
  float: left;
  transform: scale(0);
  animation: hollow-dots-spinner-animation 1000ms ease infinite 0ms;
}

.hollow-dots-spinner .dot:nth-child(1) {
  animation-delay: calc(300ms * 1);
}

.hollow-dots-spinner .dot:nth-child(2) {
  animation-delay: calc(300ms * 2);
}

.hollow-dots-spinner .dot:nth-child(3) {
  animation-delay: calc(300ms * 3);
}

@keyframes hollow-dots-spinner-animation {
  50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
